const diagrams: Record<number, { title: string; nodes: string[] }> = {
  0: { title: '最小系统', nodes: ['3.3 V 电源', '复位 / BOOT', 'STM32F103C8T6', 'HSE 8 MHz', 'SWD / ST-Link'] },
  1: { title: '内存映射访问', nodes: ['C 表达式', '地址 + 数据', 'AHB/APB 总线', '外设寄存器'] },
  2: { title: '内核与总线', nodes: ['Cortex-M3', 'AHB', 'Flash / SRAM', 'APB1', 'APB2'] },
  3: { title: 'LED 回路', nodes: ['GPIO PC13', '330 Ω', 'LED', '3.3 V / GND'] },
  4: { title: '按键事件链', nodes: ['上拉按键', 'GPIO 输入', 'EXTI', 'NVIC', 'ISR'] },
  5: { title: '定时器通道', nodes: ['TIMxCLK', 'PSC', 'CNT / ARR', 'CCR', 'PWM 引脚'] },
  6: { title: '采样链路', nodes: ['传感电压', 'ADC S/H', '12 位 SAR', 'DMA', 'SRAM 数组'] },
  7: { title: '串口链路', nodes: ['STM32 TX', 'USB-UART RX', 'USB', '终端'] },
  8: { title: '同步总线', nodes: ['STM32 主机', 'SCL / SCK', 'SDA / MOSI', '传感器 / OLED'] },
  9: { title: '可靠性域', nodes: ['LSI / LSE', 'IWDG / RTC', 'PWR', 'SRAM / Backup'] },
  10: { title: 'RTOS 内核', nodes: ['任务', '队列 / 锁', 'Scheduler', 'SysTick / PendSV'] },
  11: { title: '调试观测', nodes: ['电源测量', 'SWD', 'CPU / 寄存器', '逻辑分析', '软件状态'] },
  12: { title: '分层架构', nodes: ['硬件 / BSP', '器件 Driver', 'Service', 'App / Tasks', '验收测试'] },
};

export function TopologyDiagram({ chapterId }: { chapterId: number }) {
  const diagram = diagrams[chapterId] ?? diagrams[0];
  return <div className="topology" role="img" aria-label={`${diagram.title}简化结构图`}><div className="topology-title">{diagram.title}</div><div className="topology-nodes">{diagram.nodes.map((node, index) => <div key={node} className={index === Math.floor(diagram.nodes.length / 2) ? 'core' : ''}><span>{node}</span>{index < diagram.nodes.length - 1 && <i>→</i>}</div>)}</div><p>教学简化图 · 实际连接与复用请以 STM32F103C8T6 数据手册、参考手册及所用开发板原理图为准。</p></div>;
}
